<template>
  <form action="" method="post" @submit.prevent="submit">
    <TextBox
      label="Name"
      name="name"
      placeholder="Enter your name"
      v-model="form.name"
      :disabled="form.processing"
      :error="form.errors.name"
    />
    <TextBox
      label="Email"
      name="email"
      placeholder="Enter your email"
      v-model="form.email"
      :disabled="form.processing"
      :error="form.errors.email"
    />
    <TextBox
      type="number"
      label="Mobile number"
      name="mobile"
      placeholder="Enter your mobile number"
      v-model="form.mobile"
      :disabled="form.processing"
      :error="form.errors.mobile"
    />
    <div class="mt-4 text-center">
      <button
        class="btn btn-primary w-75"
        type="submit"
        :disabled="form.processing || !hasChanges"
        @click.prevent="submit"
      >
        <div
          class="spinner-border spinner-border-sm"
          role="status"
          v-if="form.processing"
        ></div>
        <span v-else>Save</span>
      </button>
    </div>
  </form>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      type: "update",
      form: this.$inertia.form({
        name: null,
        email: null,
        mobile: null,
      }),
    };
  },
  mounted() {
    this.PageTitle("My profile");

    this.form.name = this.user.name;
    this.form.email = this.user.email;
    this.form.mobile = this.user.mobile;
  },
  methods: {
    submit() {
      this.form.post(this.$route("admin.profile.update"));
    },
  },
  computed: {
    user() {
      return this.$page.props.user;
    },
    hasChanges() {
      return (
        this.form.name != this.user.name ||
        this.form.email != this.user.email ||
        this.form.mobile != this.user.mobile
      );
    },
  },
};
</script>